import { useI18next } from 'gatsby-plugin-react-i18next';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { getDefaultSiteDescription } from '../../utils/getDefaultSiteDescription';
import { getSiteName } from '../../utils/getSiteName';

interface SeoProps {
    title?: string;
    description?: string;
    noIndex?: boolean;
}

const Seo: FC<SeoProps> = ({ title, description, noIndex }) => {
    const { language } = useI18next();
    const metaTitle = title ? title : getSiteName(language);
    const defaultDescription = getDefaultSiteDescription(language);
    const trimHtmlTagsRegexp = /<\/?[^>]+(>|$)/g;
    const safeDescription = description && description?.length > 0 ? description?.replace(trimHtmlTagsRegexp, '') : '';
    const metaDescription = safeDescription?.trim()?.length > 0 ? safeDescription : defaultDescription;

    return (
        <React.Fragment>
            <Helmet
                htmlAttributes={{ lang: language }}
                title={metaTitle}
                meta={[
                    {
                        name: 'description',
                        content: metaDescription,
                    },
                    {
                        property: 'og:title',
                        content: metaTitle,
                    },
                    {
                        property: 'og:description',
                        content: metaDescription,
                    },
                ]}
            >
                {noIndex && <meta name="robots" content="noindex" />}
            </Helmet>
        </React.Fragment>
    );
};
export default Seo;
